export var NodeContext = /* @__PURE__ */ ((NodeContext2) => {
  NodeContext2["ACTOR"] = "actor";
  NodeContext2["ANIM"] = "anim";
  NodeContext2["AUDIO"] = "audio";
  NodeContext2["COP"] = "cop";
  NodeContext2["EVENT"] = "event";
  NodeContext2["GL"] = "gl";
  NodeContext2["JS"] = "js";
  NodeContext2["MANAGER"] = "manager";
  NodeContext2["MAT"] = "mat";
  NodeContext2["OBJ"] = "obj";
  NodeContext2["POST"] = "post";
  NodeContext2["ROP"] = "rop";
  NodeContext2["SOP"] = "sop";
  return NodeContext2;
})(NodeContext || {});
export var NetworkNodeType = /* @__PURE__ */ ((NetworkNodeType2) => {
  NetworkNodeType2["ACTOR"] = "actorsNetwork";
  NetworkNodeType2["ANIM"] = "animationsNetwork";
  NetworkNodeType2["AUDIO"] = "audioNetwork";
  NetworkNodeType2["COP"] = "copNetwork";
  NetworkNodeType2["EVENT"] = "eventsNetwork";
  NetworkNodeType2["MAT"] = "materialsNetwork";
  NetworkNodeType2["POST"] = "postProcessNetwork";
  NetworkNodeType2["ROP"] = "renderersNetwork";
  NetworkNodeType2["SUBNET"] = "subnet";
  return NetworkNodeType2;
})(NetworkNodeType || {});
export var NetworkChildNodeType = /* @__PURE__ */ ((NetworkChildNodeType2) => {
  NetworkChildNodeType2["INPUT"] = "subnetInput";
  NetworkChildNodeType2["OUTPUT"] = "subnetOutput";
  return NetworkChildNodeType2;
})(NetworkChildNodeType || {});
export var CameraNodeType = /* @__PURE__ */ ((CameraNodeType2) => {
  CameraNodeType2["PERSPECTIVE"] = "perspectiveCamera";
  CameraNodeType2["ORTHOGRAPHIC"] = "orthographicCamera";
  return CameraNodeType2;
})(CameraNodeType || {});
export const CAMERA_TYPES = ["orthographicCamera" /* ORTHOGRAPHIC */, "perspectiveCamera" /* PERSPECTIVE */];
export var GlNodeType = /* @__PURE__ */ ((GlNodeType2) => {
  GlNodeType2["ATTRIBUTE"] = "attribute";
  return GlNodeType2;
})(GlNodeType || {});
export var CameraControlsNodeType = /* @__PURE__ */ ((CameraControlsNodeType2) => {
  CameraControlsNodeType2["DEVICE_ORIENTATION"] = "cameraDeviceOrientationControls";
  CameraControlsNodeType2["MAP"] = "cameraMapControls";
  CameraControlsNodeType2["ORBIT"] = "cameraOrbitControls";
  CameraControlsNodeType2["FIRST_PERSON"] = "firstPersonControls";
  CameraControlsNodeType2["PLAYER"] = "playerControls";
  CameraControlsNodeType2["MOBILE_JOYSTICK"] = "mobileJoystickControls";
  return CameraControlsNodeType2;
})(CameraControlsNodeType || {});
export const CAMERA_CONTROLS_NODE_TYPES = [
  "cameraDeviceOrientationControls" /* DEVICE_ORIENTATION */,
  "cameraMapControls" /* MAP */,
  "cameraOrbitControls" /* ORBIT */,
  "firstPersonControls" /* FIRST_PERSON */,
  "mobileJoystickControls" /* MOBILE_JOYSTICK */
];
export var AudioNodeAnalyserType = /* @__PURE__ */ ((AudioNodeAnalyserType2) => {
  AudioNodeAnalyserType2["FFT"] = "FFT";
  AudioNodeAnalyserType2["METER"] = "meter";
  AudioNodeAnalyserType2["WAVEFORM"] = "waveform";
  return AudioNodeAnalyserType2;
})(AudioNodeAnalyserType || {});
export const AUDIO_ANALYSER_NODES = [
  "FFT" /* FFT */,
  "meter" /* METER */,
  "waveform" /* WAVEFORM */
];
